import { render, staticRenderFns } from "./UiChartDonut.vue?vue&type=template&id=0e65e80e"
import script from "./UiChartDonut.vue?vue&type=script&lang=js"
export * from "./UiChartDonut.vue?vue&type=script&lang=js"
import style0 from "./UiChartDonut.vue?vue&type=style&index=0&id=0e65e80e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports